import {APP_URL} from '@/common/config.js';

export default {
    link: `${APP_URL}/img/sh-klogos.95bcf679.png`,
    filename: 'sh-klogos.95bcf679.png'
}
